import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import SelectInput from './selectInput';
import ErrorBlock from './errorBlock';
import Axios from 'axios';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import store from '../store';

const FILTERS = {
  manufacturer: {},
  series: {},
  fuel: {},
  // year: {},
  // displacement: {},
};

class RefineCVLSearchForm extends Component {
  state = {
    loading: false,
  };

  ref = React.createRef();

  componentWillMount() {
    const { data } = this.props;

    this.setState({
      data: data ? data.results : null,
      searchTerms: data ? data.searchTerms : null,
      groups: data ? data.groups : null,
      type: data ? data.type : null,
      error: false,
      currentManufacturer: '',
      loading: false,
    });
  }

  componentDidMount() {
    const { data } = this.props;
    const resultData = this.getResults(data.results, data.searchTerms);

    // Store initial facets to preserve manufacturer options
    const initialFacets = data && data.results ? data.results.facets : [];

    this.setState({
      resultData,
      initialFacets
    });

    if (resultData.manufacturer) {
      this.setState({
        currentManufacturer: resultData.manufacturer,
      });
    }

    this.updateScrollPosition();
  }

  updateScrollPosition = () => {
    if (this.ref) {
      const scrollPos = this.ref.offsetTop + this.ref.offsetHeight - 100;
      return Scroll.animateScroll.scrollTo(scrollPos, { duration: 250 });
    } else {
      return false;
    }
  };

  onClose = () => {
    this.forceUpdate();
  };

  equipmentSelected = (selectedOption) => {
    this.equipment = selectedOption;
    this.forceUpdate();
    this.updateScrollPosition();
  };

  goToResults = () => {
    const { equipment } = this.props;
    equipment(this.equipment);
  };

  getResults = (data, searchTerms) => {
    const filters = JSON.parse(JSON.stringify(FILTERS));
    const facets = data.facets;
    const arr = [];

    if (searchTerms.replace(/\s/g, '')) {
      Object.keys(filters).forEach((filterKey) => {
        const currentFacet = facets.find((facet) => facet.name.toLowerCase() === filterKey);
        if (currentFacet && currentFacet.options.length > 1) {
          delete filters[filterKey];
        } else if (data.model && data.model.length > 0) {
          filters[filterKey] = data.model[0][filterKey];

          let obj = {};
          obj[filterKey] = filters[filterKey];
          arr.push(obj);
        }
      });
    }

    return arr.reduce(function (result, currentObject) {
      Object.keys(currentObject).forEach((objectKey) => {
        result[objectKey] = currentObject[objectKey];
      });
      return result;
    }, {});
  };

  getFilter = (data) => {
    const filters = JSON.parse(JSON.stringify(FILTERS));
    const facets = data.facets;
    const filter = {};

    Object.keys(filters).some((filterKey) => {
      const currentFacet = facets.find((facet) => facet.name.toLowerCase() === filterKey);
      if (currentFacet) {
        filter[filterKey] = currentFacet.options;
        return true;
      }
      return false;
    });

    console.debug('RefineCVLSearchForm-getFilter - filter: ', filter); //

    return filter;
  };

  /**
   * Get refined data from search api based on the params data
   */
  getListDataFromApi = (params, key) => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups, type, searchTerms, currentManufacturer } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;


    params.culture = t('config.CULTURE');
    params.vtype = '2';
    params.text = (currentManufacturer && searchTerms && !searchTerms.includes(currentManufacturer)) ? `${currentManufacturer} ${searchTerms}` : (currentManufacturer || searchTerms);
    params.facets.familygroup = familyGroup;
    params.facets.family = type.value;
    params.lob = 'b2b';

    if (i18n.language === 'is') {
      params.lob = 'b2c';
    }

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        let selectOptions = [];
        const selectedFacet = response.data.facets.find(
          (facet) => facet.name.toLowerCase() === key,
        );

        if (selectedFacet) {
          selectOptions = this.getOptions(selectedFacet.options);
        } else {
          if (response.data.model[0][key]) {
            selectOptions = this.getOptions(response.data.model[0][key]);
          } else {
            selectOptions = this.getOptions(`No ${key} specified`);
          }
        }

        const newState = this.state;
        newState[key] = selectOptions;
        newState.error = false;


        this.setState(newState);

        this.forceUpdate();
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  /**
   * Repopulates lists after an option has been selected
   * @param {string} - value of key
   */
  getListData = (value) => {
    const { resultData, currentManufacturer, searchTerms } = this.state;
    const filters = JSON.parse(JSON.stringify(resultData));
    const params = {
      text: '',
      facets: {},
    };

    // this maybe a clunky way of filtering but it's clearer to
    // see what needs to be added to params for each filter
    switch (value) {
      case 'manufacturer':
        if (this.state.initialFacets) {
          const initialManufacturerFacet = this.state.initialFacets.find(
            (facet) => facet.name.toLowerCase() === 'manufacturer'
          );
          if (initialManufacturerFacet) {
            this.setState({
              manufacturer: this.getOptions(initialManufacturerFacet.options),
              error: false
            });
            this.forceUpdate();
            return;
          }
        }
        break;

      case 'series':
        params.facets.manufacturer = currentManufacturer;

        break;

      case 'fuel':
        params.facets.manufacturer = currentManufacturer;
        params.facets.series = filters.series;

        break;

      default:
        if (currentManufacturer) {
          params.facets.manufacturer = currentManufacturer;
        } else {
          params.text = searchTerms;
        }

        break;
    }

    this.getListDataFromApi(params, value);
  };

  // Get new data based on selections
  getNewData = (selectedOption, param) => {
    const { i18n, t } = this.props;
    const { searchTerms, type, currentManufacturer } = this.state;

    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const newState = { ...this.state };
    newState.resultData = { ...this.state.resultData };
    const activeFilters = {};
    const value = selectedOption.value;

    if (this.state.resultData && this.state.resultData[param] == value) {
      return;
    }
    const params = {};
    const facets = {};

    this.setState({ loading: true });

    params.culture = t('config.CULTURE');
    params.vtype = '2';
    const textVal = (param === 'manufacturer') ? value : currentManufacturer;
    params.text = (textVal && searchTerms && !searchTerms.includes(textVal)) ? `${textVal} ${searchTerms}` : (textVal || searchTerms);
    params.lob = 'b2b';

    if (i18n.language === 'is') {
      params.lob = 'b2c';
    }

    facets.family = type.value;
    newState.resultData[param] = value;

    if (param === 'manufacturer') {
      newState.currentManufacturer = value;
    }

    let found = false;
    Object.keys(FILTERS).forEach((filterKey) => {
      if (found) {
        newState[filterKey] = null;
      }
      if (filterKey === param) {
        found = true;
      }
    });

    Object.keys(newState.resultData).some((resultKey) => {
      facets[resultKey] = newState.resultData[resultKey];
      activeFilters[resultKey] = newState.resultData[resultKey];

      return resultKey === param;
    });

    params.facets = {
      ...facets,
      family: type.value,
    };
    newState.resultData = activeFilters;

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        newState.data = response.data;

        if (newState.data && newState.data.model && newState.data.model.length > 0) {
          if (
            newState.data.facets.filter((facet) => facet.name.toLowerCase() !== 'year').length ===
            0 ||
            newState.data.model.length === 1
          ) {
            Object.keys(FILTERS).forEach((filterKey) => {
              if (newState.data.model[0][filterKey]) {
                const value = newState.data.model[0][filterKey];
                newState.resultData[filterKey] = value;
              }
            });
            newState.data.facets = [];
          }
        }

        console.debug('RefineCVLSearchForm-getNewData - newState.data: ', newState.data); //
        console.debug(
          'RefineCVLSearchForm-getNewData - newState.resultData: ',
          newState.resultData,
        ); //

        this.equipment = null;
        newState.loading = false;
        this.setState(newState);
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error'), loading: false });
        console.warn(error);
      });

    this.forceUpdate();
  };

  getOptions = (optionsData) => {
    const arr = [];

    if (typeof optionsData === 'object') {
      optionsData.forEach((option) => {
        const options = {
          value: option,
          label: option,
        };

        arr.push(options);
      });
    } else {
      const options = {
        value: optionsData,
        label: optionsData,
      };

      arr.push(options);
    }

    return arr;
  };

  getEquipmentList = (model) => {
    const arr = [];

    model.forEach((element) => {
      let options = {};
      options.value = element.display_name_short;
      options.label = element.display_name_short;
      options.key = element.equipment;
      arr.push(options);
    });

    return arr;
  };

  handleBackToSearch = () => {
    this.setState({
      data: null,
      resultData: null,
      searchTerms: null,
      error: false,
    });

    if (this.props.onBackToSearch) {
      this.props.onBackToSearch();
    }

    if (window && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  };

  getSelectInput = (filterData, onOpen, disabled) => {
    return Object.keys(filterData).map(function (key) {
      let options = [];

      options = filterData[key]
        ? this.getOptions(filterData[key])
        : this.getOptions(`No ${key} specified`);

      return (
        <SelectInput
          title={key}
          onListOpen={onOpen ? this.getListData : null}
          onClose={this.onClose}
          selectOptions={this.state[key] ? this.state[key] : null}
          key={key}
          value={key}
          selected={filterData[key]}
          options={options}
          handleChange={filterData[key] ? this.getNewData : null}
          disabled={disabled}
        />
      );
    }, this);
  };

  render() {
    const { i18n, t, selectedFamily } = this.props;
    const { data, resultData, error, loading } = this.state;
    const equipmentList = this.getEquipmentList(data.model);
    const filter = this.getFilter(data);

    // Remove manufacturer from filter if it's already in resultData to avoid duplicates
    if (resultData && resultData.manufacturer && filter.manufacturer) {
      delete filter.manufacturer;
    }

    const resultDropdownInputs = resultData ? this.getSelectInput(resultData, true, loading) : '';
    const filterInput = filter ? this.getSelectInput(filter, false, loading) : '';

    if (Object.keys(equipmentList).length === 1) this.equipment = equipmentList[0];

    const errorBlock = <ErrorBlock error={error} />;

    const loader = (
      <div className="loading-block">
        <div className="loader" />
      </div>
    );

    const button = (
      <a
        className="button"
        onClick={() => {
          this.goToResults();
          ReactGA.event({
            category: i18n.language,
            action: selectedFamily,
            label: 'See Recommendation',
          });
        }}
      >
        {t('generic_labels.recommendation')}
      </a>
    );

    const results = (
      <div className="results">
        {this.equipment &&
          data.facets.filter(
            (facet) =>
              facet.name.toLowerCase() !== 'year' && facet.name.toLowerCase() !== 'familygroup',
          ).length === 0
          ? button
          : ''}
      </div>
    );

    const inputs = (
      <div className="inputs">
        {resultDropdownInputs}
        {filterInput}

        {data.facets.filter(
          (facet) =>
            facet.name.toLowerCase() !== 'year' && facet.name.toLowerCase() !== 'familygroup',
        ).length === 0 ? (
          <SelectInput
            key="equipment"
            title
            handleChange={this.equipmentSelected}
            options={equipmentList}
            onClose={this.onClose}
            value="equipment"
          />
        ) : (
          ''
        )}
      </div>
    );

    return (
      <section className="refine-search-form" ref={(node) => (this.ref = node)}>
        <button className="back-to-search" onClick={this.handleBackToSearch}>
          <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-3.93402e-07 9L8.92466 -9.07161e-08L11 2.09286L4.15069 9L11 15.9071L8.92466 18L-3.93402e-07 9Z" fill="white" />
          </svg>
          <span>{t('vehicle_spec.start_new_search')}</span>
        </button>
        {inputs}
        {results}
        {errorBlock}
        {loading && loader}
      </section>
    );
  }
}

export default translate('translations')(RefineCVLSearchForm);
